import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-microscopic-observation',
  templateUrl: './microscopic-observation.component.html',
  styleUrls: ['./microscopic-observation.component.css']
})
export class MicroscopicObservationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
